export default "__VITE_ASSET__0ZupvihT__"